import { Modal } from "react-bootstrap";

export default function CommonModal({ show, onClose, children }) {
    return (
        <Modal show={show} onHide={onClose} centered >
            
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
}
